// Hand-drawn-feeling psychedelic flourishes lifted from the 2026
// poster's vocabulary (mushrooms, snake stripe, hummingbird, sunburst).
// Pure SVG — they scale clean and inherit color so we can re-tint per
// section without needing image files.

export const Mushroom = ({ size = 40, color = "currentColor", spotColor = "#fff", ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" {...rest}>
    <path
      d="M10 30 C10 16, 22 6, 32 6 C42 6, 54 16, 54 30 C54 33, 52 35, 48 35 L16 35 C12 35, 10 33, 10 30 Z"
      fill={color}
    />
    <circle cx="22" cy="22" r="4" fill={spotColor} opacity="0.9" />
    <circle cx="38" cy="18" r="3" fill={spotColor} opacity="0.9" />
    <circle cx="44" cy="26" r="2.5" fill={spotColor} opacity="0.9" />
    <path
      d="M26 35 L26 54 C26 56, 28 58, 32 58 C36 58, 38 56, 38 54 L38 35 Z"
      fill="#f5e7c4"
    />
    <line x1="29" y1="40" x2="29" y2="54" stroke="#0d2a26" strokeWidth="0.8" opacity="0.4" />
    <line x1="35" y1="40" x2="35" y2="54" stroke="#0d2a26" strokeWidth="0.8" opacity="0.4" />
  </svg>
);

export const Hummingbird = ({ size = 70, color = "currentColor", ...rest }) => (
  <svg width={size} height={size * 0.75} viewBox="0 0 100 75" aria-hidden="true" {...rest}>
    {/* Stylized poster-style hummingbird in flight */}
    <path
      d="M68 38 C58 28, 42 26, 30 32 C20 36, 12 44, 8 52 C18 50, 28 48, 38 48 C46 48, 56 46, 68 44 Z"
      fill={color}
    />
    <path
      d="M68 38 L94 24 L84 40 L96 48 L72 50 Z"
      fill={color}
      opacity="0.85"
    />
    <circle cx="34" cy="40" r="2.2" fill="#0d2a26" />
    <path d="M14 50 L4 56 L8 46 Z" fill={color} opacity="0.7" />
    <path d="M28 52 L20 62 L24 50 Z" fill={color} opacity="0.7" />
  </svg>
);

export const SnakeStripe = ({ height = 24, color = "#f06c33", color2 = "#f3b740", ...rest }) => (
  <svg width="100%" height={height} viewBox="0 0 600 24" preserveAspectRatio="none" aria-hidden="true" {...rest}>
    <path
      d="M0 12 Q 50 0, 100 12 T 200 12 T 300 12 T 400 12 T 500 12 T 600 12"
      stroke={color}
      strokeWidth="6"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M0 14 Q 50 26, 100 14 T 200 14 T 300 14 T 400 14 T 500 14 T 600 14"
      stroke={color2}
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
      strokeDasharray="2 8"
    />
  </svg>
);

export const SunBurst = ({ size = 220, color = "#f3b740", ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" aria-hidden="true" {...rest}>
    {Array.from({ length: 24 }).map((_, i) => {
      const angle = (i / 24) * Math.PI * 2;
      const x1 = 100 + Math.cos(angle) * 50;
      const y1 = 100 + Math.sin(angle) * 50;
      const x2 = 100 + Math.cos(angle) * 95;
      const y2 = 100 + Math.sin(angle) * 95;
      return (
        <line
          key={i}
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke={color}
          strokeWidth={i % 2 ? 3 : 5}
          strokeLinecap="round"
        />
      );
    })}
    <circle cx="100" cy="100" r="40" fill={color} />
  </svg>
);

export const Squiggle = ({ width = 120, height = 16, color = "currentColor", ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 120 16" aria-hidden="true" {...rest}>
    <path
      d="M2 8 Q 12 2, 22 8 T 42 8 T 62 8 T 82 8 T 102 8 T 118 8"
      stroke={color}
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

export const Leaf = ({ size = 50, color = "currentColor", ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" {...rest}>
    <path
      d="M32 4 C12 12, 6 30, 12 50 C30 50, 50 38, 56 18 C50 14, 42 10, 32 4 Z"
      fill={color}
    />
    <path d="M16 46 C 24 36, 36 26, 50 18" stroke="#0d2a26" strokeWidth="1.4" opacity="0.4" fill="none" />
  </svg>
);
